import OrdersTabs from './OrdersTabs';

export default OrdersTabs;
